export default __webpack_public_path__ + "static/media/extensivo-r3-cirurgia.20a5b522.svg";